import React, { useState } from "react";
import Header from "../Header/Header";
import SetDisplayname from "../SetDisplayname/SetDisplayname";
import Event from "../Event/Event";
import WaitingForEvent from "../WaitingForEvent/WaitingForEvent";
import Chat from "../Chat/Chat";

import { RecaptchaVerifier, ConfirmationResult } from "firebase/auth";

import { useApp } from "../../contexts/AppContext";

declare global {
  interface Window {
    recaptchaVerifier: RecaptchaVerifier;
    confirmationResult: ConfirmationResult;
  }
}

function LoggedIn() {
  const {
    state: { globalUser, event, selectedPartyId },
  } = useApp();

  const hasNickname = globalUser?.nickName;
  const [isChatOpen, setIsChatOpen] = useState(false);

  const canShowChat = !!selectedPartyId;

  return (
    <>
      <Header onOpenChat={canShowChat ? () => setIsChatOpen(true) : undefined} />
      <>
        {!hasNickname && <SetDisplayname />}
        {hasNickname && !event && <WaitingForEvent />}
        {hasNickname && event && <Event />}
      </>
      {canShowChat && isChatOpen && (
        <Chat onClose={() => setIsChatOpen(false)} />
      )}
    </>
  );
}

export default LoggedIn;
